
import Ajax from '../js/common/ajax';
/**
 * 账簿相关接口
 */
export default {
	loadSubject(params = {}) {
		return Ajax.get("/accountBook/list", params)
	},
	// 加载所有科目（包含辅助核算期初有金额的科目）
	loadSubject1(params = {}) {
		return Ajax.get("/accountBook/list1", params)
	},
	loadVoucherDetails(params = {}) {
		return Ajax.get("/accountBook/details", params)
	},
	loadGeneralLedger(params = {}) {
		return Ajax.get("/accountBook/generalLedger", params)
	},
	loadSubjectBalance(params = {}) {
		return Ajax.get("/accountBook/subjectBalance", params)
	},
	loadSubjectBalance2(params = {}) {
		return Ajax.get("/accountBook/subjectBalance2", params)
	},
	loadAuxiliarySubjectBalance(params = {}) {
		return Ajax.get("/accountBook/subjectAuxiliaryBalance", params)
	},
	// 科目1002银行存款
	loadAuxiliarySubjectBalance1(params = {}) {
		return Ajax.get("/accountBook/subjectAuxiliaryBalance1", params)
	},
	// 科目1001库存现金
	loadAuxiliarySubjectBalance2(params = {}) {
		return Ajax.get("/accountBook/subjectAuxiliaryBalance2", params)
	},
	// 21号前的凭证
	loadAuxiliarySubjectBalance3(params = {}) {
		return Ajax.get("/accountBook/subjectAuxiliaryBalance3", params)
	},

	loadSubjectSummary(params = {}) {
		return Ajax.get("/accountBook/subjectSummary", params)
	},
	loadAuxiliaryDetails(params = {}) {
		return Ajax.get("/accountBook/auxiliaryDetails", params)
	},
	loadAuxiliaryList(params = {}) {
		return Ajax.get("/accountBook/auxiliaryList", params)
	},
	loadAuxiliaryList2(params = {}) {
		return Ajax.get("/accountBook/auxiliaryList2", params)
	},
	loadAuxiliaryAll() {
		return Ajax.get("/accountBook/auxiliaryList1")
	},
	loadAuxiliaryBalance(params = {}) {
		return Ajax.get("/accountBook/auxiliaryBalance", params)
	},
	loadAuxiliarySummary(params = {}) {
		return Ajax.get("/accountBook/auxiliarySummary", params)
	},
}